import React from "react";
import { connect } from "react-redux";
import * as helper from "../utils/helper";
import { useHistory } from "react-router-dom";

function Question(props: { question: any, key: any , users?:any }) {
  const { question } = props;
  const history = useHistory();
  const [user] = props.users.filter((u:any) => u.id === question.author);
  function viewPoll() {
    history.push(`/questions/${question.id}`);
  }
  function AllQuestions() {
    return (
      <div className="container card1" style={{ marginBottom: "20px" }}>
        <div className="row col-12 title_bg">{user.name}</div>
        <p className="dateFormat">{helper.formatDate(question.timestamp)}</p>
        <div className="row">
          <div className="avatar col-4">
            <img className="image" src={user.avatarURL} alt="avatar" />
          </div>
          <div className="col-8">
            <p className="title">Would You Rather</p>
            <p className="content">* {question.optionOne.text}</p>
            <p className="content">or</p>
            <p className="content">* {question.optionTwo.text}</p>
          </div>
        </div>
        <div className="row viewBtn">
          <div className="col-3"></div>
          <button onClick={viewPoll} className="btn alert-success btn-sm col-6">
            View Poll
          </button>
          <div className="col-3"></div>
        </div>
      </div>
    );
  }

  return <AllQuestions />;
}

const mapStateToProps = (state:any) => {
  return {
    users: state.userReducer.users,
  };
};

export default connect(mapStateToProps, null)(Question);
